import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
export {captureEffectiveRoleRecord, shouldEffectiveRoleBeCaptured} from './effectiveRole'

const accessModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default accessModule
